import React from "react";
import { Bell, Menu } from "lucide-react";
import UserDropdown from "../user-dropdown/user-dropdown";
import { UserRole } from "../../core/roles/roles.type";
import { AppTheme, ColorMode } from "../../core/theme/theme.config";
import Search from "../../platform/search/search";

interface HeaderViewProps {
    role: UserRole;
    mode: ColorMode;
    activeTheme: AppTheme;
    onNavigate: (path: string) => void;
    onLogout: () => void;
    onMenuToggle: () => void;
    handleThemeChange: (theme: AppTheme) => void;
    handleModeToggle: () => void;
}

function HeaderView(props: HeaderViewProps) {

    return (
        <header className="pn-header">
            <div className="pn-header__left">
                <button
                    className="pn-header__menu-btn"
                    type="button"
                    onClick={props.onMenuToggle}
                    aria-label="Open navigation menu"
                >
                    <Menu size={18} strokeWidth={1.75}/>
                </button>
                <Search />
                {/*<div className="pn-header__search">*/}

                {/*    <input*/}
                {/*        name="People Nest Search"*/}
                {/*        type="search"*/}
                {/*        className="pn-header__search-input"*/}
                {/*        placeholder="Search…"*/}
                {/*        aria-label="Global search"*/}
                {/*    />*/}
                {/*</div>*/}
            </div>

            <div className="pn-header__right">


                {/*<button className="pn-header__icon-btn" aria-label="Notifications">*/}
                {/*    <Bell size={16} strokeWidth={1.75}/>*/}
                {/*    <span className="pn-header__notify-dot" aria-hidden="true"/>*/}
                {/*</button>*/}

                {/*<button*/}
                {/*    className={`pn-mode-btn pn-mode-btn--${mode}`}*/}
                {/*    onClick={handleModeToggle}*/}
                {/*    aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}*/}
                {/*    title={isLight ? "Switch to dark mode" : "Switch to light mode"}*/}
                {/*>*/}
                {/*    <span className="pn-mode-btn__sun" aria-hidden="true"><Sun size={16} strokeWidth={1.75}/></span>*/}
                {/*    <span className="pn-mode-btn__moon" aria-hidden="true"><Moon size={16} strokeWidth={1.75}/></span>*/}

                {/*    /!*<Sun className="pn-mode-btn__sun" size={16} strokeWidth={1.75}/>*!/*/}
                {/*    /!*<Moon className="pn-mode-btn__moon" size={16} strokeWidth={1.75}/>*!/*/}
                {/*</button>*/}

                {/*<div className="pn-header__divider" aria-hidden="true"/>*/}

                <UserDropdown
                    role={props.role}
                    mode={props.mode}
                    activeTheme={props.activeTheme}
                    onThemeChange={props.handleThemeChange}
                    onModeToggle={props.handleModeToggle}
                    onNavigate={props.onNavigate}
                    onLogout={props.onLogout}
                />
            </div>
        </header>
    );
}

export default HeaderView;
